import React, { Component } from 'react';
import './hotRecommendList.less';
import HotRecommendItem from './hotRecommendItem';
import ABSSubTitle from '../../../../../components/ABSSubTitle';

export interface IABSHotRecommendListProps {
  hotRecommend?: any;
  recommendType: string;
  bgName?: string;
  
}

class HotRecommendList extends Component<IABSHotRecommendListProps> {
  renderDetail = (hotRecommend: any, recommendType: string) => {
    return hotRecommend.map((item, key) => {
      if (key > 9) { return null; }
      return (
        <HotRecommendItem isHot={item.is_hot} recommendType={recommendType} name={item.name} percert={item.percert} key={item.key} toId={item.key}/>
      );
    });
  }

  renderHotCommend = () => {
    const { hotRecommend, recommendType } = this.props;
    if (hotRecommend && Array.isArray(hotRecommend) && hotRecommend.length > 0) {
      return (
        <div className="abs-home-right-hot-recommend-list-content">
          {this.renderDetail(hotRecommend, recommendType)}
        </div>
      );
    } else {
      return (
        <div className="abs-home-right-hot-recommend-list-nodata">暂无数据</div>
      );
    }

  }

  render() { 
    const { bgName, recommendType } = this.props;
    return (
      <div className="abs-home-right-hot-recommend-list">
        <ABSSubTitle title={recommendType} className={`abs-home-right-hot-recommend-list-type ${bgName}`} />
        {this.renderHotCommend()}
      </div>
    );
  }
}

export default HotRecommendList; 



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/right/hotRecommendList.tsx